import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AttachmentsService, QueryService, WorkspaceService } from '@pt/api-client';
import { WorkspaceItem, WorkspaceItemType, WorkspaceMoveRequest } from '@primatoo-ms-organization';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { WidgetDialogService } from '../../services/widget-dialog.service';
import * as AttachmentActions from '../actions/attachment.actions';


/**
 * ATTENZIONE....
 *
 * l'ATTACHMENT a differenza degli altri effect ha SOLO Alcuni metodi e non va utilizzato per copiare ed incollare l'effect
 * @giovanni
 */

@Injectable()
export class AttachmentEffects {

  moveAttachment$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(AttachmentActions.moveAttachment),
      switchMap((action: { id: number, workspaceMoveRequest: WorkspaceMoveRequest }) =>
        this.workspaceService.move(action.id, WorkspaceItemType.ATTACHMENT, action.workspaceMoveRequest).pipe(
          map((item: WorkspaceItem) =>
            AttachmentActions.moveAttachmentSuccess({item})
          ),
          catchError(err => of(
            AttachmentActions.moveAttachmentFailed({error: err.message})
          ))
        )
      )
    );
  });

  constructor(
    private store: Store,
    private actions$: Actions,
    private queryService: QueryService,
    private widgetDialogService: WidgetDialogService,
    private attachmentService: AttachmentsService,
    private workspaceService: WorkspaceService
  ) {
  }
}
